// Section 5 and 16: Charismatic. Trust changes for their household spread to two other
// households at 0.3x (society stream applies the spread). Constants: config.traits.charismatic.
import { defineTrait, noModifiers } from '../../core/registry';
import { neverRestricts } from '../../core/content-helpers';
import type { Config } from '../../config';

export function charismatic(_config: Config) {
  return defineTrait({
    id: 'charismatic',
    label: 'Charismatic',
    section: 'S5',
    modifierTargets: [],
    modifiers: noModifiers,
    restricts: neverRestricts,
  });
}
